/* eslint-disable import/prefer-default-export */
import Client from '@/domain/models/Client';
import StringHelper from '@/helpers/StringHelper';
import IWebhookBaseParams from '@/repositories/parameters/IWebhookBaseParams';
import { DateTime } from 'luxon';
import ClientRepository from '@/repositories/ClientRepository';
import UpdateClientInfoParams from '../types/UpdateClientInfoParams';
import CustomerParametersValidationException from '../errors/CustomerParametersValidationException';

export const getFormattedLimit = (limit: string | null |number | undefined): number|undefined => {
  if (typeof limit === 'number') {
    return limit;
  }

  if (typeof limit === 'string') {
    return parseFloat(
      limit
        .replaceAll('.', '')
        .replaceAll(',', '.'),
    );
  }

  return undefined;
};

export const validateCustomerFields = (customerData: Client): string[] => {
  const inputErrors: string[] = [];

  if (!customerData.ddd) {
    inputErrors.push('DDD obrigatório.');
  }

  if (customerData.ddd && customerData.ddd.length !== 2) {
    inputErrors.push('DDD deve ser ter somente 2 caracteres.');
  }

  if (customerData.phone && customerData.phone.length > 15) {
    inputErrors.push('Telefone deve ter no máximo 15 caracteres.');
  }

  if (customerData.invoiceMail) {
    if (customerData.invoiceMail.length > 150) {
        inputErrors.push('Email NFE deve ter no máximo 150 caracteres.');
    }
    const splitedMails = customerData.invoiceMail.replaceAll(' ', '').split(';');

    if (!splitedMails.every((mail) => StringHelper.isEmail(mail))) {
      inputErrors.push('Email NFE está inválido!');
    }
  }

  if (customerData.financialMail1) {
    if (customerData.financialMail1.length > 150) {
        inputErrors.push('Email Financeiro 1 deve ter no máximo 150 caracteres.');
    }

    if (!StringHelper.isEmail(customerData.financialMail1)) {
      inputErrors.push('Email Financeiro 1 está inválido!');
    }
  }

  if (customerData.group && customerData.group.length > 10) {
    inputErrors.push('Grupo deve ter no máximo 10 caracteres.');
  }

  if (customerData.subGroup && customerData.subGroup.length > 10) {
    inputErrors.push('Sub-Grupo deve ter no máximo 10 caracteres.');
  }

  if (customerData.deadline && customerData.deadline.length > 3) {
    inputErrors.push('Sub-Grupo deve ter no máximo 3 caracteres.');
  }

  if (customerData.companyId === null) {
    inputErrors.push('Este cliente não possui o id da empresa que pertence!');
  }

  return inputErrors;
};

export const saveChanges = async (
  idCustomer: string,
  companyGroupId: number,
  customerData: Client,
): Promise<void> => {
  const inputErrors = validateCustomerFields(customerData);

  if (inputErrors.length > 0) {
    throw new CustomerParametersValidationException(inputErrors[0]);
  }

  const clientParameters: IWebhookBaseParams<UpdateClientInfoParams> = {
      id: idCustomer,
      data: {
        phone: customerData.phone.replace('-', ''),
        ddd: customerData.ddd!,
        invoiceMail: customerData.invoiceMail,
        financialMail1: customerData.financialMail1,
        financialName1: customerData.financialName1,
        financialName2: customerData.financialName2,
        group: customerData.group,
        subGroup: customerData.subGroup,
        deadline: customerData.deadline,
        limit: getFormattedLimit(customerData.limit),
        risk: customerData.risk,
        clientClass: customerData.clientClass,
        notes: customerData.notes,
        tradeName: customerData.tradeName,
        companyName: customerData.companyName,
        document: customerData.cnpj.replace(/[^0-9]/g, ''),
        store: customerData.store,
        stateRegistration: customerData.stateRegistration,
        address: customerData.address,
        complement: customerData.complement,
        city: customerData.city,
        neighbourhood: customerData.neighbourhood,
        state: customerData.state,
      },
  };

  const clientRepository = new ClientRepository();

  await clientRepository.updateCustomerAdditionalInformation(
    customerData.companyId!,
    companyGroupId,
    clientParameters,
  );
};
